import DownloadRequestForQuotePDF from "./DownloadRequestForQuotePDF";

export default DownloadRequestForQuotePDF;
